import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import './studyStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import studyClasses from './studyStyles';
import { SRLWrapper } from "simple-react-lightbox";

const images = [
  { id: '1', imageName: 'casestudy-screenshot-1.jpg' },
  { id: '2', imageName: 'casestudy-screenshot-2.jpg' },
  { id: '3', imageName: 'casestudy-screenshot-3.jpg' },
  { id: '4', imageName: 'casestudy-screenshot-4.jpg' },
  { id: '5', imageName: 'casestudy-screenshot-5.jpg' },
  { id: '6', imageName: 'casestudy-screenshot-6.jpg' },

];



const options = {
  buttons: {
    backgroundColor: 'rgba(30,30,36,0.8)',
    iconColor: 'rgba(255, 255, 255, 0.8)',
    iconPadding: '10px',
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: true,
    showPrevButton: true,
    showThumbnailsButton: false,
    size: '40px'
  }, 
  settings: {
    autoplaySpeed: 3000,
    boxShadow: 'none',
    disableKeyboardControls: false,
    disablePanzoom: true,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.3,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(30, 30, 30, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 50],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
    usingPreact: false
  },
 
};



function StudyOverview() {
  const globalClasses = globalUseStyles()
  const studyStyles = studyClasses()
  return (
    <ThemeProvider theme={theme}>
      <Container className={"studyOverviewStyle"} maxWidth={false} component="section">
          <Container className={"studyOverviewStyleInner"} maxWidth={false} component="section">
            <Grid className={globalClasses.containerTopPadding} container>
                <Grid className={globalClasses.containerSmall} container >
                  <Grid item xs={12} md={4}  >
                      <Typography variant="subtitle1">Background</Typography>
                      <Typography variant="h2">Overview</Typography>
                  </Grid>                  
                  <Grid item xs={12} md={8} container >
                      <Typography variant="body1">The Rosalyn Carter Institute for Caregivers (RCI) promotes the health, strength, and resilience of caregivers at every stage of their journey. RCI has been collecting data on caregivers in paper forms and assessments but has never had a technology solution that could collect such data electronically, aggregate the information, and provide business analytics to drive the direction of their organization and programming. </Typography>
                      <Typography variant="body1">RCI needed the capability to easily collect data digitally in order to scale their programming and reach more caregivers, as well as gain insights into how to best serve caregivers moving forward. </Typography>
                  </Grid>
                  <SRLWrapper options={options}>
                  <Grid  item xs={12} sm={12} md={12} container spacing={2}>
                  { images.map(image => 
                        <Grid item xs={12} md={4} key={image.id}>
                          <Button className={studyStyles.buttonImageGallery}>
                            <img className={studyStyles.imageGallery} src={`/images/${image.imageName}`} alt=""/>
                    
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </SRLWrapper>
                </Grid>
            </Grid>
          </Container>
      </Container>
    </ThemeProvider>
  );
};

export default StudyOverview;